import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { supabase } from '../../utils/supabase';
import { planService } from '../../services/planService';
import PlanGate from './PlanGate';

const PrivateRoute = ({ children, redirectTo, skipPlanCheck = false }) => {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [planAccess, setPlanAccess] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // Vérifier l'authentification
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      if (session && !skipPlanCheck) {
        checkPlanAccess();
      } else {
        setLoading(false);
      }
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      if (session && !skipPlanCheck) {
        checkPlanAccess();
      } else {
        setLoading(false);
      }
    });

    return () => subscription.unsubscribe();
  }, [location.pathname, skipPlanCheck]);

  /**
   * Vérifier l'accès basé sur le plan pour la route actuelle
   */
  const checkPlanAccess = async () => {
    try {
      // Passer la session actuelle au planService pour éviter la double vérification
      const hasAccess = await planService.canAccessRoute(location.pathname, session);
      console.log('hasAccess', hasAccess);
      setPlanAccess(hasAccess);
    } catch (error) {
      console.error('Erreur lors de la vérification d\'accès au plan:', error);
      // En cas d'erreur, autoriser l'accès par défaut
      setPlanAccess(true);
    } finally {
      setLoading(false);
    }
  };

  // État de chargement
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  // Redirection si pas de session
  if (!session) {
    return <Navigate to="/login" />;
  }

  // Redirection personnalisée si spécifiée
  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  // Contrôle d'accès basé sur le plan
  if (planAccess === false) {
    return (
      <PlanGate
        type="route"
        feature={location.pathname}
        className="min-h-screen"
      >
        {children}
      </PlanGate>
    );
  }

  return children;
};

export default PrivateRoute;
